import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Organization } from 'src/API';
import { crudReducer, CrudStatus } from './crud-state-slice';

export interface OrganizationObject extends Organization {
  description: string;
  id: string;
  name: string;
  role: string;
  isDefault?: boolean;
}
interface OrganizationBaseState {
  listOrganizations: OrganizationObject[];
}
type OrganizationState = OrganizationBaseState & CrudStatus<OrganizationBaseState>;

const initialState: OrganizationState = {
  listOrganizations: [],
  _status: {},
};

// type SetListAction = PayloadAction<string[]>
// type SetListOrganizationAction = PayloadAction<OrganizationObject[]>
// type UpdateUserAction = PayloadAction<User>

const reducers = {
  ...crudReducer<OrganizationState>(),
  listOrganizations: (state: OrganizationState, action: PayloadAction<OrganizationObject[]>) => {
    state.listOrganizations = action.payload;
    console.log('listOrganizations', action.payload);
  },
};

export const slice = createSlice({
  name: 'Organization',
  initialState,
  reducers,
});

export const { reducer } = slice;
